import type { AbstractSubmitStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { ClickableBlock } from "@ui/components/ClickableBlock";
import { formatText } from "@ui/format";
import { ProgressButton } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { CONFIG } from "../../Calculator/data";
import type { HomeSavingsResponseItem } from "../types";

export interface StepFields {}

interface Props extends AbstractSubmitStepProps {
	results: HomeSavingsResponseItem[];
	selectResult: (result: HomeSavingsResponseItem) => void;
}

export class Result extends AbstractSubmitStep<StepFields, Props> {
	protected renderContent(_values: StepFields): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				<Card.Header className="bg-success text-center text-white h4 py-2">
					A várhatóan <mark className="bg-white text-success">legkedvezőbb</mark> ajánlatok
				</Card.Header>
				<Card.Body>{this.renderResults()}</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton type="submit" state={submitState}>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	private renderResults(): ReactNode {
		const { results } = this.props;

		return results.slice(0, CONFIG.MAX_RESULTS).map((res) => this.renderSingleResult(res));
	}

	private renderSingleResult(res: HomeSavingsResponseItem): ReactNode {
		return (
			<ClickableBlock
				className="shadow-sm flex-column py-2 my-2 result-item rounded"
				onClick={() => this.resultClick(res)}
				key={res.id}
			>
				<div className="result-header text-center">
					<strong>{res.bank.name}</strong>
					<br />
					Megtakarítás időtartama: {res.savingsPeriod} hónap
				</div>
				<div className="result-body text-center">
					<div className="d-flex align-items-center py-2">
						<div className="result-data col">
							<strong>{formatText(res.aer, "%")}</strong>
							<br />
							<span className="result-type">EBKM</span>
						</div>
						<div className="result-data col">
							<strong>{formatText(res.accountOpeningFee, "ft")}</strong>
							<br />
							<span className="result-type">Számlanyitási díj</span>
						</div>
						<div className="result-data col last">
							<strong>{formatText(res.interestBonusRate, "0%")}</strong>
							<br />
							<span className="result-type">Kamatbónusz</span>
						</div>
					</div>
				</div>
			</ClickableBlock>
		);
	}

	private resultClick(res: HomeSavingsResponseItem): void {
		const { selectResult } = this.props;
		selectResult(res);
		this.onStep("lead-form");
	}

	protected getComponentName(): string {
		return "Result";
	}
}
